import { FieldError } from 'react-hook-form';
import { useMeterConfigurationContext } from '../context';

export const useMeterConfigErrorMessage = () => {
  const { serverErrors } = useMeterConfigurationContext();

  const getErrorMessage = (index: number, property: string, error: FieldError | undefined) => {
    if (error?.message) return error.message;
    return (serverErrors[index]?.[property] as string) || null;
  };

  return {
    getErrorMessage,
  };
};
